export default __webpack_public_path__ + "static/media/background_skor.a348b956.png";